import { Description } from 'common/components/description';
import { TrialCounter } from 'common/components/trial';
import { Epg } from 'common/constants/data-types';
import { DetailInfoStripeItem } from 'common/interfaces';
import { getClassName } from 'common/utils';
import React from 'react';
import MiniPlayer from './MiniPlayer';

export interface DetailedInfoProps extends DetailInfoStripeItem {
  active?: boolean;
  hasHeader?: boolean;
  hidden?: boolean;
}

function DetailedInfo(props: DetailedInfoProps) {
  // const props = props.epg;
  return (
    <div
      className={getClassName('detailed-info-container', {
        visible: props.active,
        'has-header': props.hasHeader,
        hidden: props.hidden
      })}
    >
      <Description
        numeration={props.epg.numeration}
        persons={props.epg.persons}
        originaltitle={props.epg.originaltitle}
        title={props.epg.title}
        start={props.epg.start}
        stop={props.epg.stop}
        shorttext={props.epg.shorttext}
        fulltext={props.epg.fulltext}
        actors={props.epg.actors}
        year={props.epg.year}
        country={props.epg.country}
        major_category={props.epg.major_category}
        minor_categories={props.epg.minor_categories}
        duration={props.epg.duration}
        rating={props.epg.rating}
        resolution={props.resolution}
      />
      <MiniPlayer
        {...(props.epg as Epg)}
        active={props.active}
        isLiveCard={props.isLiveCard}
        thumbnailUrl={props.thumbnailUrl}
      />
      <TrialCounter />
    </div>
  );
}
export default React.memo(DetailedInfo);
